import React, { useState, useEffect } from "react";
import bsBreakpoints from "bs-breakpoints";
import classNames from "classnames";
import { AiFillFilePdf } from "react-icons/ai";
import CustomIcon from "../CustomIcon/CustomIcon";
import PageSection from "../PageSection/PageSection";
import ResponsivePageHeader from "../ResponsivePageHeader/ResponsivePageHeader";
import { Col, Row } from "react-bootstrap";

const DepartmentAboutInfoResponsive = (props) => {
  const [currentBreakPoint, setCurrentBreakPoint] = useState("");

  const descriptionClasses = classNames("mb-4 text-center text-text-color", {
    "font-sm": currentBreakPoint === "xSmall" || currentBreakPoint === "small",
  });

  useEffect(() => {
    bsBreakpoints.init();
    setCurrentBreakPoint(bsBreakpoints.getCurrentBreakpoint());

    const handleBreakPoint = (event) => {
      setCurrentBreakPoint(event.detail);
    };

    window.addEventListener("new.bs.breakpoint", handleBreakPoint);

    return () => {
      window.removeEventListener("new.bs.breakpoint", handleBreakPoint);
    };
  }, []);

  return (
    <PageSection bgClass="background-color">
      <ResponsivePageHeader centered={true} title={props.title} />
      <p className={descriptionClasses}>{props.desc}</p>
      <Row className="justify-content-center">
        <Col md="3">
          <a
            href={props.href}
            className="d-flex align-items-center justify-content-center text-uppercase text-center text-highlight-color text-highlight-color-hover text-highlight-color-active font-weight-medium font-sm font-paragraph-font"
            target="_blank"
            rel="noopener noreferrer"
          >
            <CustomIcon currentIcon={AiFillFilePdf} size="md" />
            <span className="ml-2">{props.docLinkText}</span>
          </a>
        </Col>
      </Row>

      {/* <a
				href={"https://drive.google.com/drive/folders/14c87huWmPY4h1Yhinmr1uyQVBcu3WqLU?usp=drive_link"}
				className="d-flex align-items-center justify-content-center text-uppercase text-center text-link-color font-weight-medium font-sm font-paragraph-font"
				target="_blank"
				rel="noopener noreferrer"
				
			>
				<CustomIcon currentIcon={AiFillFilePdf} size="md" />
				<span  className="ml-2">Syllabus</span>
			</a> */}
    </PageSection>
  );
};

export default DepartmentAboutInfoResponsive;
